import { handlers as eTax } from './eTax';
import { handlers as mainPage } from './mainPage';
import { handlers as productTag } from './productTag';
import { handlers as storeExpense } from './storeExpense';

export const handlers = [...eTax, ...mainPage, ...productTag, ...storeExpense];
